import React from "react";
import {
  Container,
  FormField,
  Header,
  Multiselect,
  SelectProps,
  SpaceBetween,
  Toggle,
} from "@amzn/awsui-components-react";

interface PncAccessSectionProps {
  pncEnabled: boolean;
  pncUsers: string[];
  ownerOptions: SelectProps.Option[];
  onToggleOn: () => void;
  onToggleOff: () => void;
  onPncUsersChange: (users: string[]) => void;
}

const PncAccessSection: React.FC<PncAccessSectionProps> = ({
  pncEnabled,
  pncUsers,
  ownerOptions,
  onToggleOn,
  onToggleOff,
  onPncUsersChange,
}) => {
  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Restrict this audit to specific team members only. When enabled, only listed users can see or access this audit."
        >
          Private &amp; Confidential
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="m">
        <Toggle
          checked={pncEnabled}
          onChange={({ detail }) => {
            if (detail.checked) {
              onToggleOn();
            } else {
              onToggleOff();
            }
          }}
        >
          Mark this audit as Private &amp; Confidential
        </Toggle>
        {pncEnabled && (
          <FormField
            label="Users with access"
            description="Select team members who should have access to this audit. You will be included automatically."
          >
            <Multiselect
              selectedOptions={(pncUsers ?? []).map((u) => ({
                label: u,
                value: u,
              }))}
              options={ownerOptions}
              onChange={({ detail }) =>
                onPncUsersChange(
                  detail.selectedOptions.map((o) => o.value as string),
                )
              }
              filteringType="auto"
              tokenLimit={5}
              placeholder="Select team members"
            />
          </FormField>
        )}
      </SpaceBetween>
    </Container>
  );
};

export default PncAccessSection;
